import { useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, StatusTabs } from "@/components/patterns";
import { MyNotificationsPage } from "@/pages/settings/MyNotificationsPage";
import { MyDisplayPage } from "@/pages/settings/MyDisplayPage";
import { MyCallingPage } from "@/pages/settings/MyCallingPage";
import { MySecurityPage } from "@/pages/settings/MySecurityPage";

/** Settings → Preferences: everything a person sets for themselves, in tabs (Notifications, Display, Calling, Security) */
export function PreferencesPage() {
  const { hasPermission } = useAuth();
  const [params, setParams] = useSearchParams();
  const tabs = [
    { key: "notifications", label: "Notifications" },
    { key: "display", label: "Display" },
    ...(hasPermission("call.make") ? [{ key: "calling", label: "Calling" }] : []),
    { key: "security", label: "Security" },
  ];
  const asked = params.get("tab") || "";
  const tab = tabs.some((t) => t.key === asked) ? asked : "notifications";
  const setTab = (t: string) => {
    const next = new URLSearchParams(params);
    next.set("tab", t);
    setParams(next, { replace: true });
  };

  return (
    <div className="mx-auto max-w-3xl space-y-4">
      <PageHeader title="Preferences" />
      <StatusTabs label="Preferences" active={tab} onChange={setTab} tabs={tabs} />
      <div role="tabpanel" aria-label={tabs.find((t) => t.key === tab)?.label}>
        {tab === "notifications" && <MyNotificationsPage embedded />}
        {tab === "display" && <MyDisplayPage embedded />}
        {tab === "calling" && <MyCallingPage embedded />}
        {tab === "security" && <MySecurityPage embedded />}
      </div>
    </div>
  );
}
